function pageTitle({title}){
    return(

        <div className="page-title-header"> 
            <h2 className="page-title-text-header">{title}</h2>
        </div>

    );

}

export default pageTitle;